"use client";

import {FirebaseConfig} from "@/libs/config";
import {
  Analytics,
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties
} from "firebase/analytics";
import {getApp, getApps, initializeApp} from "firebase/app";
import {usePathname, useSearchParams} from "next/navigation";
import {
  ReactNode,
  createContext,
  useCallback,
  useEffect,
  useState
} from "react";
import {useNeoContext} from "../neo/neo.context";
const app = !(typeof window !== "undefined" && getApps().length)
  ? initializeApp(FirebaseConfig)
  : getApp();

interface FirebaseContextProps {
  tracking: Analytics | null;
  reportAnalyticsLog: any;
}

export const FirebaseContext = createContext<FirebaseContextProps | undefined>(
  undefined
);

export const FirebaseContextProvider = (props: {children: ReactNode}) => {
  const [tracking, setTracking] = useState<Analytics | null>(null);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {filterContext} = useNeoContext();
  // console.log("FirebaseContextProvider", filterContext.client);
  const handleRouteChange = useCallback(
    (url: string) => {
      if (tracking) {
        setTimeout(() => {
          const currentUser = filterContext.client;
          if (currentUser?.institutionUserName) {
            setUserId(tracking, currentUser?.institutionUserName);
            setUserProperties(tracking, {
              // institutionUserName: currentUser?.institutionUserName,
              // institutionId: currentUser?.institutionId,
              // clientId: currentUser?.clientId
              Organization: currentUser.institutionName || "unknown_school",
              Organization_User:
                currentUser.institutionUserName || "unknown_username"
            });
          }

          // logEvent(tracking, "custom_page_view", {
          //   debug_mode: true,
          //   page_title: document?.title
          // });
          logEvent(tracking, "page_view", {
            page_location: url,
            page_title: document?.title
          });
        }, 1000);
      }
    },
    [tracking, filterContext.client.institutionUserName]
  );
  useEffect(() => {
    // Initialize Firebase Analytics
    const initializeFirebase = async () => {
      try {
        const analytics = getAnalytics();

        setTracking(analytics);
      } catch (error) {
        console.error("Failed to initialize Firebase Analytics", error);
      }
    };

    initializeFirebase();
  }, []);

  useEffect(() => {
    // Ensure page view is logged whenever pathname or searchParams change
    if (tracking) {
      const fullUrl = `${window.location.origin}${pathname}${searchParams ? `?${searchParams}` : ""}`;
      handleRouteChange(fullUrl);
    }
  }, [pathname, searchParams, tracking, handleRouteChange]);

  const reportAnalyticsLog = (reportMenu: string) => {
    if (tracking) {
      const fullUrl = `${window.location.origin}${pathname}${searchParams ? `?${searchParams}` : ""}${reportMenu ? `&reportMenu=${reportMenu}` : ""}`;
      setTimeout(() => {
        logEvent(tracking, "page_report_view", {
          //debug_mode: true,
          page_location: fullUrl,
          page_title: `Report | ${reportMenu}`
        });
      }, 1000);
    }
  };
  return (
    <FirebaseContext.Provider
      value={{tracking, reportAnalyticsLog: reportAnalyticsLog}}
    >
      {props.children}
    </FirebaseContext.Provider>
  );
};
